import { render, staticRenderFns } from "./BookInfo.vue?vue&type=template&id=783c6232&"
import script from "./BookInfo.vue?vue&type=script&lang=js&"
export * from "./BookInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports